import { useGlobalStore } from "@/store/GlobalStore";
import { Checkbox, Popover } from "@renderbus/ui";
import { message } from "antd";
import { CheckboxChangeEvent } from "antd/lib/checkbox";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { NotificationSettingApi } from "../constants";
import MultipleInput from "./multiple-input";

const FormWrapper = styled.div`
  margin-left: 20px;
`;
const FormItemWrapper = styled.div`
  display: flex;
  flex-wrap: nowrap;
  margin-top: 10px;
`;
const FormItemLabel = styled.div<{ isZh: boolean }>`
  width: ${(p) => (p.isZh ? "auto" : "200px")};
  line-height: 30px;
  margin-right: 6px;
`;
const FormItemLabelName = styled.span`
  display: inline-block;
  text-align: left;
`;
const FormItemController = styled.div`
  width: 420px;
`;
const TooltipIcon = styled.div`
  display: inline-block;
  line-height: 15px;
  width: 15px;
  border-radius: 10px;
  background: gray;
  color: white;
  text-align: center;
  cursor: pointer;
  margin-left: 4px;
  margin-right: 8px;
`;
const TooltipContent = styled.div`
  width: 140px;
  font-size: 12px;
`;
const NotificationSetting: React.FC = () => {
  const { t } = useTranslation("notification");
  const { isZh } = useGlobalStore();
  const [isDay, setIsDay] = useState(false);
  const [defaultEmail, setDefaultEmail] = useState();
  const onChange = (e: CheckboxChangeEvent) => {
    setIsDay(e.target.checked);
    NotificationSettingApi.updateDayBillNotice({
      dayBillNoticeStatus: e.target.checked ? 1 : 0,
    }).then((res) => {
      if (res.result) {
        getBillMessageSetting();
      }
    });
  };
  const [monthBillEmail, setMonthBillEmail] = useState<string[]>([]);
  const [dayBillEmail, setDayBillEmail] = useState<string[]>([]);
  const onEmailAdd = (email: string, type: 1 | 2) => {
    if (!defaultEmail) {
      message.error(t("notification_billing_email_add_no_default"));
      return false;
    }
    NotificationSettingApi.addBillNoticeEmail({ email, type }).then((res) => {
      if (res.result) {
        message.success(t("notification_billing_email_add_success"));
        getBillMessageSetting();
      }
    });
    return true;
  };
  const onEmailRemove = (email: string, type: 1 | 2) => {
    NotificationSettingApi.removeBillNoticeEmail({
      email,
      type,
    }).then((res) => {
      if (res.result) {
        message.success(t("notification_billing_email_remove_success"));
        getBillMessageSetting();
      }
    });
  };
  const getBillMessageSetting = async () => {
    const res = await NotificationSettingApi.getBillMessageSetting();
    if (res.result) {
      const { dayBillEmail, email, dayBillNoticeStatus, monthBillEmail } =
        res.data;
      const dayEmailArray = [email ?? "", ...(dayBillEmail ?? [])].filter(
        Boolean
      );
      const monthEmailArray = [email ?? "", ...(monthBillEmail ?? [])].filter(
        Boolean
      );
      setDefaultEmail(email);
      setDayBillEmail(dayEmailArray);
      setMonthBillEmail(monthEmailArray);
      setIsDay(!!dayBillNoticeStatus);
    }
  };
  useEffect(() => {
    getBillMessageSetting();
  }, []);
  return (
    <FormWrapper>
      <FormItemWrapper>
        <FormItemLabel isZh={isZh}>
          <FormItemLabelName>
            <Checkbox
              checked={true}
              style={{ marginRight: 8, visibility: "hidden" }}
            />
            {t("notification_billing_email_label_month")}
            {!defaultEmail ? (
              <Popover
                content={
                  <TooltipContent>
                    {t("notification_billing_email_label_tooltip")}
                  </TooltipContent>
                }
                trigger="hover"
              >
                <TooltipIcon>?</TooltipIcon>
              </Popover>
            ) : (
              ":"
            )}
          </FormItemLabelName>
        </FormItemLabel>
        <FormItemController>
          <MultipleInput
            inputPlaceholder={t("notification_billing_email_placeholder")}
            defaultData={monthBillEmail}
            onDataChange={(data: string[]) => setMonthBillEmail(data)}
            onAddItem={(value: string) => onEmailAdd(value, 1)}
            onRemoveItem={(value: string) => onEmailRemove(value, 1)}
            hasDefaultValue={!!defaultEmail}
          />
        </FormItemController>
      </FormItemWrapper>
      <FormItemWrapper>
        <FormItemLabel isZh={isZh}>
          <Checkbox
            checked={isDay}
            onChange={onChange}
            style={{ marginRight: 8 }}
            disabled={!defaultEmail}
          />
          <FormItemLabelName>
            {t("notification_billing_email_label_day")}
            {!defaultEmail ? (
              <Popover
                content={
                  <TooltipContent>
                    {t("notification_billing_email_label_tooltip")}
                  </TooltipContent>
                }
                trigger="hover"
              >
                <TooltipIcon>?</TooltipIcon>
              </Popover>
            ) : (
              ":"
            )}
          </FormItemLabelName>
        </FormItemLabel>
        <FormItemController>
          <MultipleInput
            inputPlaceholder={t("notification_billing_email_placeholder")}
            defaultData={dayBillEmail}
            onDataChange={(data: string[]) => setDayBillEmail(data)}
            onAddItem={(value: string) => onEmailAdd(value, 2)}
            onRemoveItem={(value: string) => onEmailRemove(value, 2)}
            hasDefaultValue={!!defaultEmail}
          />
        </FormItemController>
      </FormItemWrapper>
    </FormWrapper>
  );
};
export default NotificationSetting;
